import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { DataManipulationService } from '../services/data-manipulation.service';
import { ApiwrapperService } from '../services/apiwrapper.service';

@Injectable({
  providedIn: 'root'
})
export class TemporarGuardGuard implements CanActivate {
  constructor(private data: DataManipulationService, private api: ApiwrapperService, private router: Router) {}
  
  canActivate(
    route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const pollUuid = route.params['pollUuid'];
    return this.api.getWorkspaceCustomPoll().pipe(
      map((res) => {
        const isOnboarding = res._embedded["custom-polls"].find((poll: any) => poll.uuid === pollUuid).customPollTemplate.type === 'onboarding';
        return !isOnboarding ? true: this.router.parseUrl('/feedback-templates');
      })
    )
  }
}
